import React from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { SocialProofMini } from './components/SocialProofMini';
import { PainPoints } from './components/PainPoints';
import { ProductReveal } from './components/ProductReveal';
import { TheTomes } from './components/TheTomes';
import { TheBonuses } from './components/TheBonuses';
import { CountdownBanner } from './components/CountdownBanner';
import { Pricing } from './components/Pricing';
import { PremiumJustification } from './components/PremiumJustification';
import { TestimonialsBig } from './components/TestimonialsBig';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfNotBuying } from './components/CostOfNotBuying';
import { Footer } from './components/Footer';
import { VerifiedPopup } from './components/VerifiedPopup';
export function App() {
  return <div className="min-h-screen bg-navy-900 font-sans text-white selection:bg-gold selection:text-navy-900" data-id="element-0">
      <Hero data-id="element-1" />
      <StatsBar data-id="element-2" />
      <SocialProofMini data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductReveal data-id="element-5" />
      <TheTomes data-id="element-6" />
      <TheBonuses data-id="element-7" />
      <CountdownBanner id="countdown-top" data-id="element-8" />
      <Pricing data-id="element-9" />
      <PremiumJustification data-id="element-10" />
      <TestimonialsBig data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <CostOfNotBuying data-id="element-14" />

      {/* Final CTA Section (Repeats Countdown and Pricing) */}
      <div className="relative border-t-4 border-navy-900" data-id="element-15">
        <CountdownBanner id="countdown-bottom" data-id="element-16" />
        <Pricing data-id="element-17" />
      </div>

      <Footer data-id="element-18" />
      <VerifiedPopup data-id="element-19" />
    </div>;
}